import { _itmUserInfoAxios } from "@/plugins/itmUserInfoAxios";

// const getSugangInfo = (params) => {
//   if (params.type === "mobile") {
//     return _itmUserInfoAxios.get(
//       `/external/sugang/getSugangInfo?type=${params.type}&mobile=${params.mobile}&name=${params.name}&companyIdx=${params.code}`
//     );
//   } else {
//     return _itmUserInfoAxios.get(
//       `/external/sugang/getSugangInfo?type=${params.type}&email=${params.email}&name=${params.name}&companyIdx=${params.code}`
//     );
//   }
// };

const getSugangInfo = (params) => {
  if (params.type === "mobile") {
    return _itmUserInfoAxios.get(
      `/external/sugang/getSugangHistoryList?type=${params.type}&mobile=${params.mobile}&name=${params.name}&companyIdx=${params.code}`
    );
  } else {
    return _itmUserInfoAxios.get(
      `/external/sugang/getSugangHistoryList?type=${params.type}&email=${params.email}&name=${params.name}&companyIdx=${params.code}`
    );
  }
};

export { getSugangInfo };
